// ABOUTME: Models explicit MCP scope selection and the bounded login return path.
// ABOUTME: Keeps full curriculum opt-in and never accepts a caller-provided external redirect.
const context = "mcp:context:read";
const dependencies: Record<string, string> = {
    "mcp:resumes:read": "mcp:candidates:read",
    "mcp:reports:export": "mcp:analytics:read"
};
export const initialMcpScopes = (allowed: string[]) =>
    allowed.includes(context) ? [context] : [];
export function toggleMcpScope(
    current: string[],
    scope: string,
    checked: boolean,
    allowed: string[]
) {
    const selected = new Set(
        current.filter((value) => allowed.includes(value))
    );
    if (scope !== context) {
        if (checked && allowed.includes(scope)) {
            const dependency = dependencies[scope];
            if (!dependency || allowed.includes(dependency)) {
                selected.add(scope);
                if (dependency) selected.add(dependency);
            }
        } else {
            selected.delete(scope);
            for (const [dependent, requirement] of Object.entries(dependencies))
                if (requirement === scope) selected.delete(dependent);
        }
    }
    return [...selected];
}
export function mcpLoginReturnTarget(
    pathname: string,
    search: string
): string | null {
    const normalizedPathname =
        pathname.endsWith("/") && pathname !== "/"
            ? pathname.slice(0, -1)
            : pathname;
    if (normalizedPathname === "/mcp/download") {
        const file = new URLSearchParams(search).get("file");
        return file && /^[A-Za-z0-9_-]{43}$/.test(file)
            ? encodeURIComponent(
                  `/mcp/download?${new URLSearchParams({ file })}`
              )
            : null;
    }
    if (normalizedPathname !== "/mcp/consent") return null;
    const interaction = new URLSearchParams(search).get("interaction");
    if (!interaction || !/^[A-Za-z0-9_-]{1,256}$/.test(interaction))
        return null;
    return encodeURIComponent(
        `/mcp/consent?${new URLSearchParams({ interaction })}`
    );
}
